// Clips [data-readmore-content] with a line-clamp (so it keeps its trailing
// ellipsis at rest) and animates it open/closed from a [data-readmore-toggle]
// button. The clamp can't be transitioned, so it's swapped for an explicit
// max-height for the duration of the animation and restored afterwards.
export default function readMore(root = document) {
    root.querySelectorAll('[data-readmore]').forEach(wrapper => {
        const content = wrapper.querySelector('[data-readmore-content]');
        const toggle = wrapper.querySelector('[data-readmore-toggle]');

        if (!content || !toggle || toggle.dataset.readmoreReady) {
            return;
        }

        const clampClass = content.dataset.readmoreClamp || 'line-clamp-2';
        const label = toggle.querySelector('[data-readmore-label]') || toggle;
        const moreText = toggle.dataset.readmoreMore || 'See more';
        const lessText = toggle.dataset.readmoreLess || 'See less';

        toggle.dataset.readmoreReady = 'true';
        toggle.setAttribute('aria-expanded', 'false');

        let expanded = false;
        let clampedHeight = content.clientHeight;

        // Show the toggle only while something is actually clipped. Inside an
        // inactive tab panel the content measures 0, so this re-runs whenever the
        // box gets a size (tab shown, fonts loaded, resize) rather than once on load.
        const measure = () => {
            if (expanded || !content.clientHeight) {
                return;
            }

            clampedHeight = content.clientHeight;
            toggle.hidden = content.scrollHeight <= content.clientHeight + 1;
        };

        measure();

        if ('ResizeObserver' in window) {
            new ResizeObserver(measure).observe(content);
        }

        const afterTransition = () => {
            if (expanded) {
                content.style.maxHeight = 'none';
            } else {
                content.classList.add(clampClass);
                content.style.maxHeight = '';
            }
        };

        toggle.addEventListener('click', () => {
            expanded = !expanded;

            toggle.classList.toggle('is-open', expanded);
            toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            label.textContent = expanded ? lessText : moreText;

            if (expanded) {
                clampedHeight = content.clientHeight;
                content.style.maxHeight = `${clampedHeight}px`;
                content.classList.remove(clampClass);
                void content.offsetHeight; // flush the start value before animating
                content.style.maxHeight = `${content.scrollHeight}px`;
            } else {
                content.style.maxHeight = `${content.scrollHeight}px`;
                void content.offsetHeight;
                content.style.maxHeight = `${clampedHeight}px`;
            }

            content.addEventListener('transitionend', afterTransition, { once: true });
        });

        window.addEventListener('resize', () => {
            if (expanded) {
                content.style.maxHeight = 'none';
            }
        });
    });
}
